export enum WooCommerceDatetimeTimeSlotValue {
  Asap = 'asap'
}
